import apiClient from "../common/apiClient";

export default class DoctorController {
  async Create(data, token) {
     try {
      return await apiClient.post("/doctor", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(departmentId, data, token) {
     try {
      return await apiClient.put("/doctor/" + departmentId, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/doctor/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetAllDoctor(token) {
    try {
      return await apiClient.get("/getAllDoctor", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetDoctorsByDepartmentId(id, token) {
    try {
      return await apiClient.get("/getDoctorById/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
